import { createAsyncThunk, createSlice, isFulfilled, isRejected } from "@reduxjs/toolkit";
import { USER_PLAN_SERVICE_METHOD } from "services/commonService";
import { apiRequest } from "services/ServiceUtil";
import { SME_PAGE_SIZE } from "utils/CommonConstants";

const SLICE = "Corp_Dashboard";

const initialState: any = {
  dialogs: {
    renameList: { isOpen: false, data: {} },
    deleteList: { isOpen: false, data: {}, listType: "" },
    deleteSCList: { isOpen: false, data: {} },
    saveList: { isOpen: false, data: {} }
  },
  myView: {
    properties: { overview: [], list: [], totalRecords: 0 },
    plans: { overview: [], list: [], totalRecords: 0 }
  },
  corpLoader: false,
  summaryLoader: false,
  overviewLoader: false,
  myListsSelected: {
    listCategory: "bookmarked",
    selectedList: {},
    navigatedList: ""
  },
  createListError: {
    isError: false,
    message: "",
    isInputError: false
  },
  selectedTabs: {
    corpView: 0,
    dashboard: 0,
    myList: 0
  },
  recentlyViewedData: {},
  recentlyViewedSelected: {
    category: "",
    selectedItem: ""
  },
  isCreateInnCodeModal: false,
  listCreatedSuccess: {
    isCreated: false,
    message: ""
  },
  listEditSuccess: {
    userList: [],
    listData: null,
    type: ""
  },
  isEditListModal: false,
  selectedMappingIds: [],
  selectedUserList: [],
  searchText: {
    dasboard: "",
    myList: ""
  }
};
function isRejectedAction(action: any) {
  return action.type.endsWith("rejected");
}

export const fetchCorpDashboardPropertiesAsync = createAsyncThunk(
  `${SLICE}/fetchCorpDashboardPropertiesAsync`,
  (data: any, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.postViewPropertiesSummary, data, thunkApi)
);

export const fetchCorpDashboardPlansAsync = createAsyncThunk(`${SLICE}/view/plans/summary`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.postViewPlansSummary, data, thunkApi)
);

export const fetchCorpDashboardPropertiesOverviewAsync = createAsyncThunk(
  `${SLICE}/fetchCorpDashboardPropertiesOverviewAsync`,
  (data: any, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.postPropertiesOverview, data, thunkApi)
);

export const fetchCorpDashboardPlansOverviewAsync = createAsyncThunk(
  `${SLICE}/fetchCorpDashboardPlansOverviewAsync`,
  (data: any, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.getViewPlansOverview, data, thunkApi)
);

export const fetchRecentlyViewedData = createAsyncThunk(`${SLICE}/fetchRecentlyViewed`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.getRecentViews, {}, thunkApi, [], data)
);

export const updateRecentlyViewedData = createAsyncThunk(`${SLICE}/updateRecentlyViewed`, (data: any, thunkApi) =>
  apiRequest(USER_PLAN_SERVICE_METHOD.postRecentViews, data, thunkApi)
);

export const deleteMyList = createAsyncThunk(`${SLICE}/deleteMyList`, (data: any, thunkApi) => {
  const payload = {
    ids: data.id
  };
  return apiRequest(USER_PLAN_SERVICE_METHOD.deleteFilters, {}, thunkApi, [], payload);
});

export const deleteSCList = createAsyncThunk(`${SLICE}/deleteSCList`, (data: any, thunkApi) => {
  const payload = {
    innCodeGroupIds: data
  };
  return apiRequest(USER_PLAN_SERVICE_METHOD.deleteInncodeGroups, {}, thunkApi, [], payload);
});

export const fetchSCListById = createAsyncThunk(`${SLICE}/fetchSCListById`, (data: any, thunkApi: any) => {
  const queryPayload = {
    view: data?.view,
    page: data?.page || 0,
    engagement: data?.engagement || "",
    inncode: data.innCode || "",
    size: data?.size || SME_PAGE_SIZE
  };
  return apiRequest(USER_PLAN_SERVICE_METHOD.getInncodeGroups, {}, thunkApi, [data?.id], queryPayload);
});

export const addMemberToList = createAsyncThunk(`${SLICE}/addmemberstoList`, (data: any, thunkApi: any) => {
  const info = { newMappings: data.mappings };
  const queryPayload = {
    updateType: "addOrUpdateInncodeGroupMappings"
  };
  return apiRequest(USER_PLAN_SERVICE_METHOD.patchInncodeGroups, info, thunkApi, [data?.id], queryPayload);
});

export const fetchIndividualPropertyAsync = createAsyncThunk(
  `${SLICE}/fetchIndividual/properties`,
  (data: any, thunkApi) => apiRequest(USER_PLAN_SERVICE_METHOD.postViewInncodeGroupSummary, data, thunkApi)
);

export const DashboardSlice = createSlice({
  name: SLICE,
  initialState,
  reducers: {
    reset: (state) => {
      state.myView = {
        properties: { overview: [], list: [], totalRecords: 0 },
        plans: { overview: [], list: [], totalRecords: 0 }
      };
    },
    setCorpLoader: (state, action) => {
      state.corpLoader = action.payload;
    },
    setSelectedList: (state, action) => {
      state.myListsSelected.selectedList = action.payload;
    },
    setSelectedListCategory: (state, action) => {
      state.myListsSelected.listCategory = action.payload;
    },
    setCorpViewSelectedTab: (state, action) => {
      state.selectedTabs[action.payload.type] = action.payload.val;
    },
    resetMyListsData: (state, action) => {
      state.myListsSelected.selectedList = action.payload;
      state.myListsSelected.listCategory = "bookmarked";
      state.selectedTabs["myList"] = 0;
    },
    setNavigatedMyList: (state, action) => {
      state.myListsSelected.navigatedList = action.payload;
    },
    setRecentlyViewed: (state, action) => {
      state.recentlyViewedSelected.category = action.payload.category;
      state.recentlyViewedSelected.selectedItem = action.payload.item;
    },
    setIsCreateInnCodeModal: (state, action) => {
      state.isCreateInnCodeModal = action?.payload;
    },
    setUploadOrCreate: (state, action) => {
      state.uploadOrCreate = action?.payload;
    },
    setCreateListError: (state, action) => {
      state.createListError = action.payload;
    },
    setCreatedSuccess: (state, action) => {
      state.listCreatedSuccess = action.payload;
    },
    setEditListSuccess: (state, action) => {
      state.listEditSuccess = action.payload;
    },
    setIsEditListModal: (state, action) => {
      state.isEditListModal = action?.payload;
    },
    setDialog: (state, action) => {
      const { dialogName, isOpen, data, listType } = action.payload;
      state.dialogs[dialogName] = { isOpen, data, listType };
    },
    setPropertiesListRedux: (state, action) => {
      state.myView.properties.list = action.payload;
    },
    setSelectedMappingIds: (state, action) => {
      state.selectedMappingIds = action.payload;
    },
    setSelectedUserList: (state, action) => {
      state.selectedUserList = action.payload;
    },
    setCorpSearchText: (state, action) => {
      const { view, value } = action.payload;
      state.searchText[view] = value;
    },
    resetCorpSearchText: (state) => {
      state.searchText["dashboard"] = "";
      state.searchText["myList"] = "";
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchCorpDashboardPropertiesAsync.pending, (state, action: any) => {
        state.summaryLoader = action.meta.arg.pageable.page === 0;
      })
      .addCase(fetchCorpDashboardPropertiesAsync.fulfilled, (state, action: any) => {
        state.myView.properties.list =
          action.meta.arg.pageable.page === 0
            ? action?.payload?.properties
            : [...state.myView.properties.list, ...action.payload.properties];
        state.myView.properties.totalRecords = action.payload?.meta?.page?.total;
        state.summaryLoader = false;
      })
      .addCase(fetchCorpDashboardPropertiesAsync.rejected, (state, action: any) => {
        state.summaryLoader = false;
      })
      .addCase(fetchCorpDashboardPlansAsync.pending, (state, action: any) => {
        state.summaryLoader = true;
      })
      .addCase(fetchCorpDashboardPlansAsync.fulfilled, (state, action: any) => {
        state.myView.plans.list = action.payload.plans;

        state.summaryLoader = false;
      })
      .addCase(fetchCorpDashboardPlansAsync.rejected, (state, action: any) => {
        state.summaryLoader = false;
      })
      .addCase(fetchCorpDashboardPropertiesOverviewAsync.pending, (state, action: any) => {
        state.overviewLoader = true;
      })
      .addCase(fetchCorpDashboardPropertiesOverviewAsync.fulfilled, (state, action: any) => {
        state.myView.properties.overview = action.payload;
        state.overviewLoader = false;
      })
      .addCase(fetchCorpDashboardPropertiesOverviewAsync.rejected, (state, action: any) => {
        state.overviewLoader = false;
      })
      .addCase(fetchCorpDashboardPlansOverviewAsync.pending, (state, action: any) => {
        state.overviewLoader = true;
      })
      .addCase(fetchCorpDashboardPlansOverviewAsync.fulfilled, (state, action: any) => {
        state.myView.plans.overview = action.payload;
        state.overviewLoader = false;
      })
      .addCase(fetchCorpDashboardPlansOverviewAsync.rejected, (state, action: any) => {
        state.overviewLoader = false;
      })
      .addCase(fetchRecentlyViewedData.pending, (state) => {
        state.corpLoader = true;
      })
      .addCase(fetchRecentlyViewedData.fulfilled, (state, action: any) => {
        const { status, ...args } = action.payload;
        state.corpLoader = false;
        state.recentlyViewedData = args;
      })
      .addCase(fetchSCListById.pending, (state) => {
        state.corpLoader = true;
      })
      .addCase(fetchSCListById.fulfilled, (state, action: any) => {
        state.corpLoader = false;
      })
      .addCase(fetchSCListById.rejected, (state) => {
        state.corpLoader = false;
      })
      .addCase(fetchIndividualPropertyAsync.pending, (state) => {
        state.corpLoader = true;
      })
      .addCase(fetchIndividualPropertyAsync.fulfilled, (state, action: any) => {
        state.corpLoader = false;
      })
      .addCase(fetchIndividualPropertyAsync.rejected, (state) => {
        state.corpLoader = false;
      })
      .addCase(addMemberToList.pending, (state) => {
        state.corpLoader = true;
      })
      .addCase(addMemberToList.fulfilled, (state, action: any) => {
        state.corpLoader = false;
      })
      .addCase(addMemberToList.rejected, (state) => {
        state.corpLoader = false;
      })

      .addMatcher(isFulfilled(deleteMyList, deleteSCList), (state) => {
        state.dialogs.deleteList = { isOpen: false, data: {} };
        state.dialogs.deleteSCList = { isOpen: false, data: {} };
        state.myListsSelected.selectedList = {};
        state.myListsSelected.listCategory = "bookmarked";
      })
      .addMatcher(isRejected(deleteMyList, deleteSCList), (state) => {
        state.dialogs.deleteList = { isOpen: false, data: {} };
        state.dialogs.deleteSCList = { isOpen: false, data: {} };
      })
      .addMatcher(isRejectedAction, (state, action) => {
        state.corpLoader = false;
      });
  }
});

export const {
  setCorpLoader,
  setSelectedListCategory,
  setSelectedList,
  setCorpViewSelectedTab,
  resetMyListsData,
  setNavigatedMyList,
  setRecentlyViewed,
  setIsCreateInnCodeModal,
  setCreatedSuccess,
  setCreateListError,
  setEditListSuccess,
  setIsEditListModal,
  setDialog,
  setPropertiesListRedux,
  setSelectedUserList,
  setUploadOrCreate,
  reset,
  setCorpSearchText,
  resetCorpSearchText
} = DashboardSlice.actions;
export default DashboardSlice.reducer;
